<template>
  <div class="log-detail">
    <el-page-header @back="goBack" content="日志详情"></el-page-header>
    <el-row class="mar">
      <el-col :span="6">操作时间：{{info.startTime}}</el-col>
      <el-col :span="6">途径：{{info.channel}}</el-col>
      <el-col :span="6" v-if="isChannel == 'add'">数据来源：{{info.source}}</el-col>
      <el-col :span="6">操作方式：{{info.operateMode}}</el-col>
    </el-row>
    <el-row class="mar-b skuBtns">
      <el-button @click="handleSku('')"  :type="isSku != 'sku' ? 'primary' : 'default'" style="margin-right:0">按款式</el-button>
      <el-button @click="handleSku('sku')"  :type="isSku == 'sku' ? 'primary' : 'default'" style="margin-left:0">按sku</el-button>
    </el-row>
    <el-tabs v-model="activeName">
        <el-tab-pane label="全部" name="all">
          <span slot="label">全部（{{info.total || 0}}）</span>
          <Table @edit="handleEdit" :list="allList" :isChannel="isChannel" :isSku="isSku"/>
        </el-tab-pane>
        <el-tab-pane label="成功" name="sucess">
          <span slot="label">成功（{{info.successTotal || 0}}）</span>
          <Table @edit="handleEdit" :list="sucessList" :isChannel="isChannel" :isSku="isSku"/>
        </el-tab-pane>
        <el-tab-pane label="失败" name="fail">
          <span slot="label">失败（{{info.failureTotal || 0}}）</span>
          <Table @edit="handleEdit" :list="failList" :isChannel="isChannel" :isSku="isSku"/>
        </el-tab-pane>
    </el-tabs>
    <!-- 编辑窗口 -->
     <EditDialog ref="editDialog" :smallShopItem="true"/>
  </div>
</template>

<script>
import Table from './table.vue'
import EditDialog from "@/components/prod/center/dialogs/EditDialog.vue";
import { getOperatorLogDetail, getOperatorSkuLogDetail} from '@servers/prod/log/index'
import { prodDetailByBaseItemIds } from "@/servers/prod/center";
import { mapGetters, mapActions} from 'vuex'

export default {
  components: {
    Table,
    EditDialog
  },
  props: ['id','isBatchPrice'],
  data() {
    return {
      activeName: 'all',
      list: [],
      info: {},
      isChannel: '',
      isSku: ''
    }
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    allList() {
      return this.list || []
    },
    sucessList() {
      return this.list?.filter(item => item.status == 2 || item.status == 1)
    },
    failList() {
      return this.list?.filter(item => item.status == 0)
    },
  },

  methods: {
    handleSku(type) {
      this.activeName = 'all';
      this.isSku = type
      if(type == 'sku') {
        this.fetch_operatorSkuLogDetail()
      } else {
        this.list = []
        this.info = {}
        this.fetch_operatorLogDetail()
      }
    },
    goBack() {
      this.$router.back();
      // this.$router.replace({
      //   name: `${this.routerPrefix}prod_log`
      // })
    },
    async fetch_operatorLogDetail() {
      const res = await getOperatorLogDetail({id: this.id});
      if(!res) return;
      this.list = res.list;
      this.info = {...res.info};
      const _channel = res.info.channel;
      if(_channel == '从快麦通商品中心导入' || _channel == '从平台店铺下载' || _channel == '从快麦ERP导入' || _channel == '手工新增商品') {
        this.isChannel = 'add'
      }
      if(_channel == '商品中心设不可分销移出' || _channel == '小店商品设不可分销移出') {
        this.isChannel = 'remove'
      }
      if(_channel == '批量修改销售价') {
        this.isChannel = 'salePrice'
      }
      if(_channel == '批量改等级分销价') {
        this.isChannel = 'disPrice'
      }
    },
    async fetch_operatorSkuLogDetail() {
      this.list = [];
      this.info = {};
      const res = await getOperatorSkuLogDetail({id: this.id});
      if(!res) return;
      this.list = res.skuList;
      this.info ={
        ... res.info
      };
    },
    async handleEdit(baseItemId){
       const res = await prodDetailByBaseItemIds({
            baseItemIds: [baseItemId]
        });
        if(!res) return this.$message.error('编辑商品失败：存在商品已经被删除，请重新维护商品资料；');
        this.$refs.editDialog.method_open(res[0], {isDistributor: true, canEditOuterId: true});
    }
  },
  mounted() {
    if(this.id) {
      this.fetch_operatorLogDetail()
    }
  }

}
</script>

<style lang="scss" scoped>
.mar {
  margin:20px 0;
}
.mar-b{
  margin-bottom: 20px;
}

</style>
